import { render, staticRenderFns } from "./NikoPremiumBanner.vue?vue&type=template&id=a0f1c3c2&"
import script from "./NikoPremiumBanner.vue?vue&type=script&lang=js&"
export * from "./NikoPremiumBanner.vue?vue&type=script&lang=js&"
import style0 from "./NikoPremiumBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
installComponents(component, {VBanner})
